import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { evaluate } from '@mdx-js/mdx'
import * as runtime from 'react/jsx-runtime'
import { useTranslation } from 'react-i18next';
import { pathForChallengeImage } from 'ui/components/routing/programHelpers';
import { userSelector } from 'ui/store/user/selectors';
import { challengeSelector, createCodeStatePropSelector } from 'ui/store/code/selectors';
import Loader from 'ui/components/common/dumb/Loader';
import RegistrationInfoBox from './RegistrationInfoBox';
import * as styles from './ChallengeText.module.scss';
import { HintBox, AskForHintBox } from './HintBox';

const hintSelector = createCodeStatePropSelector('hint', 'isHintLoading', 'askForHint');

interface MDXProps {
  children: string;
}

const MDX: React.FC<MDXProps> = ({ children }) => {
  const [Content, setContent] = useState<React.ComponentType | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { default: MDXContent } = await evaluate(children, runtime as any);
        setContent(() => MDXContent);
      } catch (error) {
        console.error('Error evaluating MDX:', error);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [children]);

  if (isLoading || !Content) return null;

  return <Content />;
};


const ChallengeText: React.FC = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation('challenges');
  const { challenge } = useSelector(challengeSelector);
  const user = useSelector(userSelector);
  const { hint, isHintLoading, askForHint } = useSelector(hintSelector);

  if (challenge) {
    return (
      <div className={styles.container}>
        <div className={styles.description}>
          {!hint && isHintLoading && (
            <div className={styles['loader-container']}>
              <Loader />
            </div>
          )}

          {askForHint && <AskForHintBox />}
          {hint && !isHintLoading && <HintBox hint={hint} />}
          {!user && <RegistrationInfoBox />}
          <img
            key={challenge.id}
            src={pathForChallengeImage(challenge.id)}
            className={styles.img}
            alt={t('descriptions.alt')}
          />
          <MDX>{challenge.texts[language].description}</MDX>
        </div>
      </div>
    );
  }
  return null;
};

export default ChallengeText;
